import ProviderRegister from "./auth/ProviderRegister";

function BecomeProvider() {
  return <ProviderRegister />;
}

export default BecomeProvider;